import { Button, Container, FormGroup, Input, Label, Select, Textarea } from "@/components"
import { FlexWrapper } from "@/components/layout/flex/flexWrapper"
import { useAxios } from "@/context/axiosContext"
import { useDialog } from "@/context/dialogContext"
import { useRedis } from "@/hooks/useRedis"
import { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Col, Row } from "styled-bootstrap-grid"
import commonUtils from '@/utils/commonUtils'
import { TInput } from "@/components/forms/form-elements/types"
import DataTable from "react-data-table-component"

interface DataRow {
  cmpnyCd: string
  chnlId: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  chnlNm: string
  chnlDesc: string
  useYn: string
  useYnNm: string
  applyDate: string
  title: string
  customUrl: string
  publishedAt: string
  description: string
  thumbnailsDefault: string
  thumbnailsHigh: string
  thumbnailsMedium: string
  subscriberCount: string
  videoCount: string
  viewCount: string
  hiddenSubscriberCountYn: string
  likesCount: string

  videoId: string
  videoTitle: string
  videoPublishedAt: string
  videoThumbnail: string
}

const DetailYoutube: React.FC = () => {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();

  const [requestData] = useState({
    chnlId: location.state?.chnlId || '',
  });
  const { getComCodes, getComCodeValue } = useRedis();
  const [youtube, setYoutube] = useState<DataRow>();
  const [hist, setHist] = useState<DataRow[]>([]);

  const { showAlert, showConfirm } = useDialog();

  const description = useRef<HTMLTextAreaElement>(null);

  const getYoutube = async () => {
    const response = await axios.post('/youtube/detail', {
      chnlId: requestData.chnlId,
    });

    if (response.status == 200) {
      if (response.data.data.data) {
        response.data.data.data.useYnNm = getComCodeValue('USE_YN', response.data.data.data.useYn)?.codeNm || '';
        setYoutube(response.data.data.data);
      }
      if(response.data.data.hist && Array.isArray(response.data.data.hist)){
        setHist(response.data.data.hist);
      }
    }
  };

  const resizeTextarea = (refArea: any) => {
    if (refArea && refArea.current) {
      refArea.current.style.height = 'auto';
      refArea.current.style.height = `${refArea.current.scrollHeight > 500 ? 500 : refArea.current.scrollHeight}px`;
    }
  }

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target;
    setYoutube((prevState) => {
      return {
        ...prevState,
        [name]: value,
      } as DataRow // 모든 필드를 포함하는 상태를 유지
    })
  }


  const updateCode = async () => {
    try {
      const response: any = await axios.post('/youtube/update', youtube,)
      if (response.status == 200) {
        navigate('/youtube', { state: { searchData: location.state?.searchData}});
      } else {
        showAlert({
          title: '유튜브 채널정보 저장을 실패했어요.',
        })
      }
    } catch (error) {
      showAlert({
        title: '유튜브 채널정보 저장을 실패했어요.',
      })
      console.error('Error fetching terms reg:', error)
    }
  }

  const handleButtonDetailClick = async (applyDate: string) => {
    navigate(`/youtube/detailHist`, {
      state: {
        chnlId: youtube?.chnlId,
        applyDate: applyDate,
        searchData: location.state?.searchData,
      },
    })
  }

  useEffect(() => {
    getYoutube();
    resizeTextarea(description);
  }, []);

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ marginLeft: '20px', fontSize: '20px' }}>유튜브채널상세</p>
          <FlexWrapper gap="20px">
            <Button
              onClick={() =>
                showConfirm({
                  title: '채널목록 화면으로 이동하시겠습니까?',
                  onConfirm() {
                    navigate('/youtube', { state: { searchData: location.state?.searchData, page: location.state?.page || 1, perPage: location.state?.perPage || 10 } });
                  },
                })
              }
              color="neverbe"
              variant="outlined"
            >
              목록
            </Button>
            <Button
              onClick={() =>
                showConfirm({
                  title: '유튜브 채널정보를 저장하시겠습니까?',
                  onConfirm() {
                    updateCode();
                  },
                })
              }
              color="neverbe"
            >
              저장
            </Button>
          </FlexWrapper>
        </div>
      </div>
      <Container>
        <Row>
          <Col col={6}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chnlNm">
                채널명
              </Label>
              <Input
                id="chnlNm"
                name="chnlNm"
                type="text"
                value={youtube?.title || youtube?.chnlNm}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col={6}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chnlId">
                채널ID
              </Label>
              <Input
                id="chnlId"
                name="chnlId"
                type="text"
                value={youtube?.chnlId}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chnlDesc">
                설명
              </Label>
              <Input
                id="chnlDesc"
                name="chnlDesc"
                type="text"
                value={youtube?.chnlDesc}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="customUrl">
                고객URL
              </Label>
              <Input
                id="customUrl"
                name="customUrl"
                type="text"
                value={youtube?.customUrl}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                개설일시
              </Label>
              <Input
                id="useYn"
                name="useYn"
                type="text"
                value={commonUtils.formatDate(youtube?.publishedAt || '', true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="applyDate">
                적용일자
              </Label>
              <Input
                id="applyDate"
                name="applyDate"
                type="text"
                value={commonUtils.formatDate(youtube?.applyDate || '')}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                사용여부
              </Label>
              <Select
                id="useYn"
                name="useYn"
                value={youtube?.useYn}
                onChange={handleInputChange}
              >
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="thumbnailsDefault">
                로고URL
              </Label>
              <Input
                id="thumbnailsDefault"
                name="thumbnailsDefault"
                type="text"
                value={youtube?.thumbnailsDefault}
                disabled={true}
              />
              <Input
                id="thumbnailsMedium"
                name="thumbnailsMedium"
                type="text"
                value={youtube?.thumbnailsMedium}
                disabled={true}
              />
              <Input
                id="thumbnailsHigh"
                name="thumbnailsHigh"
                type="text"
                value={youtube?.thumbnailsHigh}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="description">
                채널설명
              </Label>
              <Textarea
                id="description"
                name="description"
                value={youtube?.description}
                disabled={true}
                height={'100%'}
                ref={description}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col={6}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="videoId">
                동영상ID
              </Label>
              <Input
                id="videoId"
                name="videoId"
                type="text"
                value={youtube?.videoId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col={6}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="videoPublishedAt">
                동영상게시일시
              </Label>
              <Input
                id="videoPublishedAt"
                name="videoPublishedAt"
                type="text"
                value={youtube?.videoPublishedAt}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="videoTitle">
                동영상제목
              </Label>
              <Input
                id="videoTitle"
                name="videoTitle"
                type="text"
                value={youtube?.videoTitle}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="videoThumnbnail">
                동영상썸네일
              </Label>
              <Input
                id="videoThumnbnail"
                name="videoThumnbnail"
                type="text"
                value={youtube?.videoThumbnail}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="subscriberCount">
                구독자수
              </Label>
              <Input
                id="subscriberCount"
                name="subscriberCount"
                type="text"
                value={(youtube?.subscriberCount?.toLocaleString() || 0)+'명'}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="viewCount">
                조회수
              </Label>
              <Input
                id="viewCount"
                name="viewCount"
                type="text"
                value={(youtube?.viewCount?.toLocaleString() || 0)+'회'}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="likesCount">
                좋아요
              </Label>
              <Input
                id="likesCount"
                name="likesCount"
                type="text"
                value={youtube?.likesCount?.toLocaleString() || 0}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="videoCount">
                동영상수
              </Label>
              <Input
                id="videoCount"
                name="videoCount"
                type="text"
                value={(youtube?.videoCount?.toLocaleString() || 0)+'개'}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                등록자
              </Label>
              <Input
                id="regId"
                name="regId"
                type="text"
                value={youtube?.regId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chnlId">
                등록일시
              </Label>
              <Input
                id="regDate"
                name="regDate"
                type="text"
                value={commonUtils.formatDate(youtube?.regDate || '', true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updId">
                수정자
              </Label>
              <Input
                id="updId"
                name="updId"
                type="text"
                value={youtube?.updId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updDate">
                수정일시
              </Label>
              <Input
                id="updDate"
                name="updDate"
                type="text"
                value={commonUtils.formatDate(youtube?.updDate || '', true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </Container>
      <DataTable
        columns={[
          {
            name: '기준일자',
            selector: (row) => commonUtils.formatDate(row.applyDate),
            center: true,
            wrap: true,
            width: '10%',
          },
          {
            name: '채널명',
            selector: (row) => row.title,
            center: true,
            wrap: true,
          },
          {
            name: '고객URL',
            selector: (row) => row.customUrl,
            center: true,
            wrap: true,
          },
          {
            name: '구독자수',
            selector: (row) => (row.subscriberCount.toLocaleString() || 0) + '명',
            center: true,
            wrap: true,
          },
          {
            name: '조회수',
            selector: (row) => (row.viewCount.toLocaleString() || 0) + '회',
            center: true,
            wrap: true,
          },
          {
            name: '영상수',
            selector: (row) => (row.videoCount.toLocaleString() || 0) + '개',
            center: true,
            wrap: true,
          },
          {
            name: '',
            cell: (row) => (
              <>
                <Button
                  variant="outlined"
                  color="neverbe"
                  size="xs"
                  onClick={() => handleButtonDetailClick(row.applyDate)}
                >
                  상세
                </Button>
              </>
            ),
            sortable: false,
          },
        ]}
        data={hist}
        pagination={true}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
        noDataComponent={<>이력이 없습니다.</>}
      />
    </>
  );
};

export default DetailYoutube;